/** Human formatting for sizes, durations and times (shared by the operations pages); sizes, durations and counts come
 * from the kit. */
export { formatBytes, formatDuration, formatCount, elapsedMs } from '@nyce/admin-kit/console';

const toMs = (t: string | number | Date) => (t instanceof Date ? t.getTime() : new Date(t).getTime());

/** `5 min ago` / `in 3 h` / `just now`; null → `never`. */
export function formatRelative(
  t: string | number | Date | null | undefined,
  now: number = Date.now(),
  never = 'never'
): string {
  if (t == null || t === '') return never;
  const at = toMs(t);
  if (!Number.isFinite(at)) return never;
  const diff = at - now;
  const abs = Math.abs(diff);
  if (abs < 45_000) return 'just now';
  const min = Math.round(abs / 60_000);
  const h = Math.round(abs / 3_600_000);
  const d = Math.round(abs / 86_400_000);
  const text =
    abs < 3_600_000 - 30_000
      ? `${Math.max(1, min)} min`
      : abs < 86_400_000 - 1_800_000
        ? `${h} h`
        : d < 60
          ? `${d} d`
          : d < 730
            ? `${Math.round(d / 30)} mo`
            : `${Math.round(d / 365)} y`;
  return diff < 0 ? `${text} ago` : `in ${text}`;
}

/** Local date and time, minutes precision; null → `—`. */
export function formatDateTime(t: string | null | undefined): string {
  if (!t) return '—';
  const d = new Date(t);
  if (!Number.isFinite(d.getTime())) return '—';
  return d.toLocaleString(undefined, {
    year: 'numeric',
    month: 'short',
    day: 'numeric',
    hour: '2-digit',
    minute: '2-digit',
  });
}
